import styled from "styled-components";

export const ExpContainer = styled.div`
  min-width: 0;
  margin-top: 1rem;
  color: var(--pallet-4);
`;
